/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowphotoeffectnone4Inputs */

const en_aiflowphotoeffectnone4 = /** @type {(inputs: Aiflowphotoeffectnone4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing`)
};

const de_aiflowphotoeffectnone4 = /** @type {(inputs: Aiflowphotoeffectnone4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nichts`)
};

/**
* | output |
* | --- |
* | "Nothing" |
*
* @param {Aiflowphotoeffectnone4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowphotoeffectnone4 = /** @type {((inputs?: Aiflowphotoeffectnone4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowphotoeffectnone4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowphotoeffectnone4(inputs)
	return de_aiflowphotoeffectnone4(inputs)
});
export { aiflowphotoeffectnone4 as "aiFlowPhotoEffectNone" }